export { default } from './quote-card';
export { default as quoteCardConfig } from './quote-card.config';
